var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FilterData } from 'path-shared/models/filter-data';
var BancCarreguesC60Filter = /** @class */ (function (_super) {
    __extends(BancCarreguesC60Filter, _super);
    function BancCarreguesC60Filter(sortField, sortDir) {
        var _this = _super.call(this, sortField, sortDir) || this;
        _this.id = null;
        _this.codiCarrega = '';
        _this.descripcioCarrega = '';
        _this.nomFitxer = '';
        _this.directoriFitxer = '';
        _this.situacio = '';
        _this.labels['id'] = _this.i18n('Id');
        _this.labels['codiCarrega'] = _this.i18n('Codi càrrega');
        _this.labels['descripcioCarrega'] = _this.i18n('Descripció càrrega');
        _this.labels['nomFitxer'] = _this.i18n('Nom fitxer');
        _this.labels['directoriFitxer'] = _this.i18n('Directori fitxer');
        _this.labels['situacio'] = _this.i18n('Situació');
        return _this;
    }
    return BancCarreguesC60Filter;
}(FilterData));
export { BancCarreguesC60Filter };
